{
  "title": "Permitir acesso à sua localização?",
  "body": "Ao permitir o acesso à sua localização, podemos confirmar que você chegou à unidade para o check-in",
  "disagree": "Recusar",
  "agree": "Aceitar"
}
